import { createAction, props } from "@ngrx/store";
import { ILicense } from "../../../../interfaces/ILicense";
import { ILicenseRequest } from "../../../../interfaces/ILicenseRequest";

export const loadLicenses = createAction(
  '[Licenses Plans] Load Licenses'
);

export const loadLicensesSuccess = createAction(
  '[Licenses Plans] Load Licenses Success',
  props<{ licenses: Array<ILicense> }>()
);

export const loadLicensesFailure = createAction(
  '[Licenses Plans] Load Licenses Failure',
  props<{ error: any }>()
);

export const createLicenseRequest = createAction(
  '[Licenses Plans] Create License Request',
  props<{ request: ILicenseRequest }>()
);

export const createLicenseRequestSuccess = createAction(
  '[Licenses Plans] Create License Request Success'
);

export const createLicenseRequestFailure = createAction(
  '[Licenses Plans] Create License Request Failure',
  props<{ error: any }>()
);